import React from "react";

function SynthesisIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 24.998 19.998">
      <path
        d="M8.749,10a5,5,0,1,0-5-5,5,5,0,0,0,5,5Zm3.75,2.5a2.464,2.464,0,0,1,.316-1.191,5.346,5.346,0,0,0-.566-.059H11.6a6.8,6.8,0,0,1-5.695,0H5.25A5.251,5.251,0,0,0,0,16.5v1.626A1.875,1.875,0,0,0,1.875,20H12.847a2.482,2.482,0,0,1-.348-1.25Zm11.249-1.25H22.5V8.124a3.125,3.125,0,0,0-6.25,0v3.125H15a1.25,1.25,0,0,0-1.25,1.25v6.25A1.25,1.25,0,0,0,15,20h8.749A1.25,1.25,0,0,0,25,18.749V12.5A1.25,1.25,0,0,0,23.748,11.249Zm-4.375,5.625a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,19.373,16.874Zm1.25-5.625h-2.5V8.124a1.25,1.25,0,0,1,2.5,0Z"
        fill="#fff"
      />
    </svg>
  );
}

export { SynthesisIcon };
